/**

 * Maps ag-Grid sort/filter models to list API request params.

 * LEAD_* whitelists must stay in sync with LeadRequestModel and uspGetLeadData.

 * BOOKING_* whitelists must stay in sync with BookingRequestModel and uspGetAllBookingSummary.

 * MASTER_* whitelists must stay in sync with MasterGridModels.cs request models.

 */



const LEAD_SORT_WHITELIST = [

    "CreatedDate",

    "FullName",

    "Mobile",

    "Email",

    "TravelCircuitName",

    "LeadType",

    "LeadStatusDescription",

    "AssignedName",

];



const LEAD_FILTER_WHITELIST = [

    "CreatedDate",

    "FullName",

    "Mobile",

    "Email",

    "TravelCircuitName",

    "LeadType",

    "LeadStatusDescription",

    "AssignedName",

];



const BOOKING_SORT_WHITELIST = [

    "BookingNo",

    "BookingDate",

    "CustomerName",

    "Mobile",

    "TravelDestination",

    "BookingType",

    "PayableAmount",

    "PaidAmount",

    "DueAmount",

];



const BOOKING_FILTER_WHITELIST = [

    "BookingNo",

    "CustomerName",

    "Mobile",

    "TravelDestination",

    "BookingType",

    "BookingDate",

    "PayableAmount",

    "PaidAmount",

    "DueAmount",

];



const TRAVEL_CIRCUIT_SORT_WHITELIST = ["TravelCircuitName", "TravelDestination"];

const TRAVEL_CIRCUIT_FILTER_WHITELIST = ["TravelCircuitName", "TravelDestination"];



const LOCATION_SORT_WHITELIST = ["LocationName", "TravelCircuitName"];

const LOCATION_FILTER_WHITELIST = ["LocationName", "TravelCircuitName"];



const VENDOR_SORT_WHITELIST = ["VendorName", "VendorCategoryName", "LocationName", "ContactNo", "Email", "PAN"];

const VENDOR_FILTER_WHITELIST = ["VendorName", "VendorCategoryName", "LocationName", "ContactNo", "Email", "PAN"];



const ROOM_CATEGORY_SORT_WHITELIST = [

    "TravelCircuitName",

    "LocationName",

    "VendorName",

    "RoomCategoryName",

    "RoomTarrif",

    "EBTarrif",

    "CNBTarrif",

];

const ROOM_CATEGORY_FILTER_WHITELIST = [

    "TravelCircuitName",

    "LocationName",

    "VendorName",

    "RoomCategoryName",

    "RoomTarrif",

    "EBTarrif",

    "CNBTarrif",

];



const URL_SORT_WHITELIST = ["UrlName", "TravelCircuitName", "SpecialistName"];

const URL_FILTER_WHITELIST = ["UrlName", "TravelCircuitName", "SpecialistName"];



const SPECIALIST_SORT_WHITELIST = ["SpecialistName", "Mobile", "Email"];

const SPECIALIST_FILTER_WHITELIST = ["SpecialistName", "Mobile", "Email"];



const ADDITIONAL_CHARGE_SORT_WHITELIST = ["ChargeDescription"];

const ADDITIONAL_CHARGE_FILTER_WHITELIST = ["ChargeDescription"];



const isWhitelisted = (fieldName, whitelist) => whitelist.includes(fieldName);



const extractFilterValue = (filterEntry) => {

    if (!filterEntry || typeof filterEntry !== "object") {

        return "";

    }



    if (filterEntry.filter != null && String(filterEntry.filter).trim() !== "") {

        return String(filterEntry.filter).trim();

    }



    if (filterEntry.condition1) {

        return extractFilterValue(filterEntry.condition1);

    }



    return "";

};



/**

 * @param {Array<{ colId: string, sort: 'asc' | 'desc' }>} sortModel

 * @param {string[]} [allowedSortColumns]

 * @returns {{ SortColumn?: string, SortDirection?: string }}

 */

export const mapAgGridSortToApi = (sortModel, allowedSortColumns = BOOKING_SORT_WHITELIST) => {

    if (!Array.isArray(sortModel) || sortModel.length === 0) {

        return {};

    }



    const activeSort = sortModel.find(

        (item) => item && item.colId && item.sort && isWhitelisted(item.colId, allowedSortColumns)

    );



    if (!activeSort) {

        return {};

    }



    return {

        SortColumn: activeSort.colId,

        SortDirection: activeSort.sort,

    };

};



/**

 * @param {Object<string, object>} filterModel

 * @param {string[]} [allowedFilterFields]

 * @returns {Object<string, string>}

 */

export const mapAgGridFilterToApi = (filterModel, allowedFilterFields = BOOKING_FILTER_WHITELIST) => {

    if (!filterModel || typeof filterModel !== "object") {

        return {};

    }



    return Object.keys(filterModel).reduce((result, fieldName) => {

        if (!isWhitelisted(fieldName, allowedFilterFields)) {

            return result;

        }



        const value = extractFilterValue(filterModel[fieldName]);

        if (value) {

            result[fieldName] = value;

        }



        return result;

    }, {});

};



/**

 * Builds POST body for master grid list APIs.

 */

export const buildMasterGridParams = (currentPage, pageSize, sortModel, filterModel, sortWhitelist, filterWhitelist) => ({

    Skip: (currentPage - 1) * pageSize,

    Take: pageSize,

    ...mapAgGridSortToApi(sortModel, sortWhitelist),

    ...mapAgGridFilterToApi(filterModel, filterWhitelist),

});



export {

    BOOKING_SORT_WHITELIST,

    BOOKING_FILTER_WHITELIST,

    LEAD_SORT_WHITELIST,

    LEAD_FILTER_WHITELIST,

    TRAVEL_CIRCUIT_SORT_WHITELIST,

    TRAVEL_CIRCUIT_FILTER_WHITELIST,

    LOCATION_SORT_WHITELIST,

    LOCATION_FILTER_WHITELIST,

    VENDOR_SORT_WHITELIST,

    VENDOR_FILTER_WHITELIST,

    ROOM_CATEGORY_SORT_WHITELIST,

    ROOM_CATEGORY_FILTER_WHITELIST,

    URL_SORT_WHITELIST,

    URL_FILTER_WHITELIST,

    SPECIALIST_SORT_WHITELIST,

    SPECIALIST_FILTER_WHITELIST,

    ADDITIONAL_CHARGE_SORT_WHITELIST,

    ADDITIONAL_CHARGE_FILTER_WHITELIST,

};


